import { addressValidation, AddressValidationDeps } from 'lib/core/data/schema'

export interface BillingAddressFormValues {
  firstName: string
  lastName: string
  company: string
  countryCode: string
  regionCode: string
  street: string
  street2: string
  city: string
  postalCode: string
  phoneNumber: string
}

export const billingAddressFormSchema = {
  firstName: '',
  lastName: '',
  company: '',
  countryCode: '',
  regionCode: '',
  street: '',
  street2: '',
  city: '',
  postalCode: '',
  phoneNumber: ''
}

export const billingAddressFormValidation = (deps: AddressValidationDeps) => {
  return addressValidation(deps)
}
